import { c } from 'react-compiler-runtime';
import InputValidation from '../internal/components/InputValidation.js';
import { useFormControlContext } from './_FormControlContext.js';
import { jsx } from 'react/jsx-runtime';

const FormControlValidation = t0 => {
  const $ = c(6);
  const {
    children,
    className,
    variant,
    id,
    style
  } = t0;
  const {
    validationMessageId
  } = useFormControlContext();
  const t1 = id || validationMessageId || "";
  let t2;
  if ($[0] !== children || $[1] !== className || $[2] !== style || $[3] !== t1 || $[4] !== variant) {
    t2 = /*#__PURE__*/jsx(InputValidation, {
      className: className,
      validationStatus: variant,
      id: t1,
      style: style,
      children: children
    });
    $[0] = children;
    $[1] = className;
    $[2] = style;
    $[3] = t1;
    $[4] = variant;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
FormControlValidation.__SLOT__ = Symbol('FormControl.Validation');

export { FormControlValidation as default };
